import Konva from 'konva/konva'
import Geo from './geometrics.es6'

const cornerRadius = 4
const pointerWidth = 10
const pointerHeight = 10
const padding = 4
const color = '#888888'
const border = { color: 'Black', width: 1 }
const font = { family: 'Arial', size: 14, color: 'Black', opacity: 0.3 }
const styles = {
  unselected: {
    font: { opacity: 0.8 },
    tag: { opacity: 0 }
  },
  selected: {
    font: { opacity: 1 },
    tag: { opacity: 0.7 }
  }
}

export default class RenElementLabel extends Konva.Label {
  constructor ({
    x, y, rotation, labelRotation, text, selected, visualMode, isPositioned, absoluteSizeScale,
    setLabelRotation, setLabelPosition, changeHover, selectElement
  }) {
    super({ x, y, draggable: visualMode === 'edit' && isPositioned })
    Object.assign(this, {
      rotation,
      labelRotation,
      text,
      selected,
      visualMode,
      isPositioned,
      absoluteSizeScale,
      setLabelRotation,
      setLabelPosition,
      changeHover,
      selectElement
    })

    this._render()
    this._bindEvents()
  }

  _render () {
    this.destroyChildren()

    const { text, selected, absoluteSizeScale } = this
    const style = selected ? styles.selected : styles.unselected

    this.add(new Konva.Tag({
      pointerDirection: this._getPointerDirection(),
      pointerWidth: pointerWidth / absoluteSizeScale,
      pointerHeight: pointerHeight / absoluteSizeScale,
      cornerRadius: cornerRadius / absoluteSizeScale,
      fill: color,
      opacity: style.tag.opacity,
      strokeEnabled: true,
      stroke: border.color,
      strokeWidth: border.width / absoluteSizeScale
    }))

    this.add(new Konva.Text({
      text,
      fontFamily: font.family,
      fontSize: font.size / absoluteSizeScale,
      padding: padding / absoluteSizeScale,
      fill: font.color,
      opacity: style.font.opacity
    }))
  }

  _bindEvents () {
    this.on('click', (event) => {
      if (this.visualMode === 'edit' && this.selected && !event.evt.ctrlKey) {
        this.setLabelRotation(this._getNextPosition())
      }
      this.selectElement(event)
    })
    this.on('dragend', () => {
      const { x, y } = this.attrs
      this.setLabelPosition({ x, y })
    })
    this.on('mouseover', () => {
      this.changeHover(true)
    })
    this.on('mouseout', () => {
      this.changeHover(false)
    })
  }

  _getNextPosition () {
    if (this.labelRotation === null) {
      return 180
    }
    return (this.labelRotation + 90) % 360
  }

  _getPointerDirection () {
    const { rotation, labelRotation } = this
    const quadrant = Math.floor((Geo.angle360(rotation + labelRotation) + 45) / 90 % 4)
    switch (quadrant) {
      case 0:
        return 'down'
      case 1:
        return 'left'
      case 2:
        return 'up'
      case 3:
        return 'right'
    }
    return 'left'
  }
}
